import { computed } from 'vue';
import store from '@/study-search/store';
import { PageTitleConstructor } from '@/study-search/models/page-title';
export default class NoResults {

	private readonly pageTitleConstructor = new PageTitleConstructor();
	public readonly MAX_NUMBER_OF_RESULTS_FOR_SUGGESTIONS = 6;

	public pageTitle = computed((): string => {
		return this.pageTitleConstructor.getPageTitle();
	});

	public resultsCount = computed((): number => {
		return store.getters.getTotalSearchResults();
	});
}
